var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTopo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 24,
  viewBox: "0 0 22 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 0V18.2172L13.9128 23.4336L7.98792 18.8477L0 24V5.78276L8.0872 0.566373L14.0121 5.15235L22 0ZM13.0347 6.70306L8.96527 3.55321V17.2969L13.0347 20.4468V6.70306ZM14.8901 20.6369L20.1446 17.2477V3.3631L14.8901 6.7523V20.6369ZM7.10985 17.2477V3.3631L1.85542 6.7523V20.6369L7.10985 17.2477Z"
})));
export default SvgTopo;